import { render } from "./RhInfo.vue?vue&type=template&id=5f703c96"
import script from "./RhInfo.vue?vue&type=script&lang=js"
export * from "./RhInfo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__